import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import TrainingSurveyItem from "./TrainingSurveyItem";

class SearchTrainingSurveys extends Component {
	render() {
		const { translations } = this.props;

		return (
			<div>
				{this.props.items.length ? (
					this.props.items.map((item, i) => <TrainingSurveyItem key={i} item={item} />)
				) : (
					<div>{translations.sections.training_surveys.no_results_response}</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations
	};
};

export default connect(mapStateToProps)(SearchTrainingSurveys);



// WEBPACK FOOTER //
// ./src/components/training/surveys/SearchTrainingSurveys.js